<template>
  <div>
    <Modal
      modalId="modalCamposAlternativosItemOportunidade"
      title="Campos do equipamento"
      dialogClass="modal-lg"
      myClass="modal-campos-alternativos-item"
    >
      <template #body>
        <div v-if="carregando" class="text-muted py-4 text-center">
          <i class="fas fa-spinner fa-spin mr-1"></i>
          Carregando campos...
        </div>
        <div v-else-if="!campos.length" class="alert alert-light border mb-0 text-center">
          Nenhum campo alternativo encontrado para
          <strong>{{ equipamentoCodigo }}</strong>.
        </div>
        <div v-else>
          <div class="campos-alt-item__header mb-3">
            <span class="campos-alt-item__serie">
              <i class="fas fa-barcode mr-1"></i>
              {{ equipamentoCodigo }}
            </span>
            <span class="text-muted small">
              {{ campos.length }} campo(s)
            </span>
          </div>
          <div class="campos-alt-item__lista">
            <div
              v-for="campo in campos"
              :key="campo.codigo || campo.nome"
              class="campos-alt-item__card"
            >
              <div class="campos-alt-item__nome">{{ campo.nome || 'Campo' }}</div>
              <div class="campos-alt-item__valor">
                {{ campo.valor !== '' && campo.valor !== null && campo.valor !== undefined ? campo.valor : '—' }}
              </div>
              <div v-if="campo.observacao" class="campos-alt-item__obs">
                {{ campo.observacao }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <button
          type="button"
          class="btn btn-depth btn-secondary btn-sm"
          @click="fechar"
        >
          Fechar
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { api_erp } from '../../../api';
import Modal from '../ui/Modal.vue';

export default {
  name: 'ModalCamposAlternativosItemOportunidade',
  components: {
    Modal,
  },
  props: {
    tokenErp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      itemId: null,
      equipamentoCodigo: '',
      equipamentoLocal: 0,
      camposSalvos: [],
      campos: [],
      carregando: false,
    };
  },
  mounted() {
    $(document).on(
      'click',
      '.js-abrir-campos-alt-item',
      this.onClickAbrir
    );
  },
  beforeDestroy() {
    $(document).off(
      'click',
      '.js-abrir-campos-alt-item',
      this.onClickAbrir
    );
  },
  methods: {
    onClickAbrir(event) {
      const botao =
        event.target && typeof event.target.closest === 'function'
          ? event.target.closest('.js-abrir-campos-alt-item')
          : null;
      if (!botao) {
        return;
      }
      event.preventDefault();
      this.itemId = botao.getAttribute('data-item-id');
      this.equipamentoCodigo = botao.getAttribute('data-equipamento') || '';
      this.equipamentoLocal = botao.getAttribute('data-local') || 0;
      let campos = [];
      try {
        campos = JSON.parse(botao.getAttribute('data-campos') || '[]');
      } catch (e) {
        campos = [];
      }
      this.camposSalvos = Array.isArray(campos) ? campos : [];
      this.abrir();
    },
    erpConfig(extra = {}) {
      return {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + this.tokenErp,
        },
        params: { ...extra },
      };
    },
    async abrir() {
      if (!this.tokenErp) {
        window.showToastDanger('body', 'Usuário sem autorização no ERP.');
        return;
      }
      this.carregando = true;
      this.campos = [];
      $('#modalCamposAlternativosItemOportunidade').modal('show');
      try {
        const response = await api_erp.get(
          '/app/equipamentos/' +
            encodeURIComponent(this.equipamentoCodigo) +
            '/campos-alternativos',
          this.erpConfig({ local: this.equipamentoLocal || 0 })
        );
        const camposApi = response.data?.data?.campos || [];
        const mapaSalvos = {};
        this.camposSalvos.forEach((campo) => {
          if (campo && campo.codigo !== undefined && campo.codigo !== null) {
            mapaSalvos[campo.codigo] = campo;
          }
        });
        this.campos = camposApi.map((campo) => {
          const salvo = mapaSalvos[campo.codigo] || {};
          return {
            codigo: campo.codigo,
            nome: campo.nome,
            valor:
              salvo.valor !== undefined &&
              salvo.valor !== null &&
              String(salvo.valor) !== ''
                ? salvo.valor
                : campo.valor || '',
            observacao:
              campo.observacao || campo.valores || salvo.observacao || '',
          };
        });
        if (!this.campos.length && this.camposSalvos.length) {
          this.campos = this.camposSalvos;
        }
      } catch (error) {
        if (this.camposSalvos.length) {
          this.campos = this.camposSalvos;
        } else {
          window.showToastDanger(
            'body',
            'Erro ao carregar campos do equipamento.'
          );
        }
      } finally {
        this.carregando = false;
      }
    },
    fechar() {
      const modal = document.getElementById(
        'modalCamposAlternativosItemOportunidade'
      );
      const ativo = document.activeElement;
      if (modal && ativo && modal.contains(ativo) && typeof ativo.blur === 'function') {
        ativo.blur();
      }
      $('#modalCamposAlternativosItemOportunidade').modal('hide');
    },
  },
};
</script>

<style scoped>
.campos-alt-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.campos-alt-item__serie {
  display: inline-flex;
  align-items: center;
  background: #f1f3f5;
  border: 1px solid #e9ecef;
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #343a40;
}

.campos-alt-item__lista {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.75rem;
}

.campos-alt-item__card {
  background: #fafbfc;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem;
}

.campos-alt-item__nome {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 0.35rem;
}

.campos-alt-item__valor {
  font-size: 0.95rem;
  font-weight: 600;
  color: #212529;
  word-break: break-word;
}

.campos-alt-item__obs {
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: #868e96;
}
</style>
